import { useApiPersonServiceAreasRetrieve } from '@rover/rsdk/src/apiClient/latest/api-person-service-areas-retrieve';
import type { EnhancedPersonSitterProfileService } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileService';
import { PersonServiceAreas } from '@rover/rsdk/src/apiClient/latest/model/personServiceAreas';

import { getLocationString } from '../utils/utils';

type UseServiceAreaMapParams = {
  opk: string | undefined;
  serviceType: string | undefined;
  services: EnhancedPersonSitterProfileService[];
  enabled: boolean;
};

type UseServiceAreaMapResult = {
  data: PersonServiceAreas | undefined;
  locationLabel: string | null;
  isLoading: boolean;
  serviceProfileType: string | undefined;
};

const useServiceAreaMap = ({
  opk,
  serviceType,
  services,
  enabled,
}: UseServiceAreaMapParams): UseServiceAreaMapResult => {
  const { data, isLoading } = useApiPersonServiceAreasRetrieve(opk!, undefined, {
    query: { enabled: enabled && !!opk },
  });
  const service = services.find((s) => s.serviceType.slug === serviceType);
  const serviceProfileType = service?.serviceProfile.serviceProfileType;
  const currentServiceMeta = service?.meta;
  const locationLabel = getLocationString(currentServiceMeta);
  return { data, locationLabel, isLoading, serviceProfileType };
};

export default useServiceAreaMap;
